import { Component, Inject, OnInit } from '@angular/core';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { ButtonComponent } from '../button/button.component';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';

@Component({
  selector: 'app-pdf-view-box',
  templateUrl: './pdf-view-box.component.html',
  styleUrls: ['./pdf-view-box.component.scss'],
  imports: [PdfViewerModule, ButtonComponent],
})
export class PdfViewBoxComponent {
  pdfSrc: string;
  constructor(
    @Inject(DIALOG_DATA) public data: any,
    private dialogRef: DialogRef
  ) {
    this.pdfSrc = data.pdfSrc;
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
